import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { NftItemTileAuctionDetails } from '../NftItemTileAuctionDetails.tsx';
import { NftItemTileItemDetails } from '../NftItemTileItemDetails.tsx';

import styles from './styles/nftItemTileContent.scss';
import { type CreatorContent_nftItem$key } from './__generated__/CreatorContent_nftItem.graphql.ts';
import { type CreatorContent_nftAuction$key } from './__generated__/CreatorContent_nftAuction.graphql.ts';

const nftItemFragment = graphql`
    fragment CreatorContent_nftItem on NftItem {
        ...NftItemTileItemDetails_nftItem
        ...NftItemTileAuctionDetails_nftItem
    }
`;
const nftAuctionFragment = graphql`
    fragment CreatorContent_nftAuction on NftAuction {
        ...NftItemTileAuctionDetails_nftAuction
    }
`;

type Props = {
    nftItem: CreatorContent_nftItem$key;
    nftAuction: CreatorContent_nftAuction$key | null | undefined;
    currency: string;
    fireTracking?: () => void;
};

export const CreatorContent: FC<Props> = ({
    nftItem: nftItemRef,
    nftAuction: nftAuctionRef,
    currency,
    fireTracking = () => {},
}) => {
    const nftItem = useFragment(nftItemFragment, nftItemRef);
    const nftAuction = useFragment(nftAuctionFragment, nftAuctionRef);

    return (
        <div className={styles.detailsSection}>
            <NftItemTileItemDetails
                nftItem={nftItem}
                fireTracking={fireTracking}
                creatorDisplay="none"
            />
            <NftItemTileAuctionDetails
                nftAuction={nftAuction}
                nftItem={nftItem}
                currency={currency}
                showFiatPrice={false}
            />
        </div>
    );
};
